@if (externalTenantId()) {
  <div class="view-wrapper" [nbSpinner]="!!(saving$ | async)">
    @if (formSignal()) {
      <wr-split-view>
        <div left class="panel">
          <div class="panel-list">
            @for (folder of paginatedFolders(); track folder.id) {
              <div
                class="list-item"
                [class.selected]="selectedFolderId() === folder.id"
                (click)="selectedFolderId.set(folder.id)">
                <div class="color-swatch" [style.background]="folder.color"></div>
                <span>{{ folder.name }}</span>
              </div>
            }
          </div>
          @if (externalTenantFolders().length > pageSize) {
            <wr-pagination-button-group
              [(ngModel)]="folderPageValue"
              [entityCount]="externalTenantFolders().length"
              [size]="pageSize">
            </wr-pagination-button-group>
          }
        </div>
        <div right class="panel">
          @if (selectedFolderControl(); as folderControl) {
            <span class="panel-title">{{ panelTitle() }}</span>
            <input nbInput fullWidth placeholder="Dienstleister filtern..." [(ngModel)]="contractorFilterValue">
            <div [formGroup]="folderControl">
              <div formArrayName="contractors" class="panel-list" (scroll)="onContractorListScroll($event)">
                @for (item of visibleContractorItems(); track item.contractor.id) {
                  <div class="list-item" [formGroupName]="item.formArrayIndex">
                    <nb-icon icon="person-outline" pack="eva"></nb-icon>
                    <nb-checkbox formControlName="allowed">{{ item.contractor.name }}</nb-checkbox>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="no-selection-hint">Wähle einen Ordner aus der Liste aus.</div>
          }
        </div>
      </wr-split-view>
    } @else {
      <div class="loading">
        <nb-spinner status="primary"></nb-spinner>
      </div>
    }
  </div>
} @else {
  <div class="no-selection-hint">Wähle einen Kunden aus um die Ordner Konfiguration zu sehen!</div>
}
